export default function BrandIntro() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
        <div>
          <span className="text-sm font-semibold tracking-wide text-primary-600">品牌介绍</span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
            让追更这件事，变得简单又可靠
          </h2>
          <p className="mt-5 leading-relaxed text-foreground-600">
            我爱漫画网诞生于一群资深漫画迷的「吐槽」——追的连载太多，总是记不清哪部更新了、读到第几话了。于是我们决定做一款真正为漫画迷设计的追更收藏工具。
          </p>
          <p className="mt-4 leading-relaxed text-foreground-600">
            从收藏清单到连载更新提醒，从追漫日历到进度保存，我们把追更过程中最琐碎、最容易出错的部分交给系统，让你把时间留给真正热爱的故事。如今，已有超过六十万漫画迷选择用我爱漫画网管理自己的追更生活。
          </p>
          <div className="mt-6 flex flex-wrap gap-2">
            {['热爱创作', '尊重作者', '专注体验', '陪伴成长'].map((t) => (
              <span key={t} className="rounded-full bg-primary-100 px-4 py-1.5 text-sm font-medium text-primary-700">
                {t}
              </span>
            ))}
          </div>
        </div>

        <div className="relative overflow-hidden rounded-3xl">
          <img
            src="https://readdy.ai/api/search-image?query=warm%20cozy%20illustration%20of%20a%20group%20of%20friends%20reading%20comics%20together%20in%20a%20sunlit%20room%20with%20plants%20and%20bookshelves%2C%20orange%20amber%20and%20cream%20palette%2C%20soft%20playful%20manga%20style%2C%20lively%20and%20friendly%20atmosphere%2C%20clean%20composition%2C%20no%20text&width=1200&height=900&seq=about-team&orientation=landscape"
            alt="漫画迷一起阅读追更插画"
            className="h-full w-full object-cover object-center"
          />
        </div>
      </div>
    </section>
  );
}